module.exports = __webpack_public_path__ + "media/images/pic/anime/bird-60d85ab7f7d17cd8e0db94c5e8b6d8d5.svg";